<script setup lang="ts">

import SvgVue from '@/application/components/SvgVue.ts';

defineProps<{ mobilNumber: string }>();
</script>

<template>
  <a target="_blank" aria-label="Chat on WhatsApp" :href="`https://wa.me/${mobilNumber}`">
    <SvgVue icon="whatsapp/WhatsAppButtonWhiteMedium.svg" alt="Chat on WhatsApp" />
  </a>
</template>
